<template>
  <Modal position="center" ref="modalRef" width="37rem">
    <template #body>
      <View direction="column" align="center" gap="md">
        <IconTile icon="x-close-circle" size="large" color="red" shape="rounded" :colored-icon="true" />

        <Text variant="h2">Decline this application?</Text>
        <Text variant="body-large" color="secondary" align="center">
          Applicants will be notified of your decision. You can always reconsider an application after initially
          declining.
        </Text>
      </View>
    </template>

    <template #footer>
      <View gap="md" justify="space-between" :grow="1" class="actions">
        <Button @click="modalRef?.close()" variant="ghost">I'll consider further</Button>
        <Button
          @click="declineApplication()"
          :loading="renterProfileStore.bundles.bundleOperationInProgress"
          appearance="danger"
          variant="secondary"
        >
          Decline
        </Button>
      </View>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { Button, IconTile, Modal, Text, View, useAlertsStore } from '@tallo/design-system';

import { useRenterProfileStore } from '../store/renter-profile.store';

const props = defineProps<{
  bundleId: string;
}>();

const alerts = useAlertsStore();
const renterProfileStore = useRenterProfileStore();

const modalRef = ref<InstanceType<typeof Modal>>();

async function declineApplication(): Promise<void> {
  await renterProfileStore.declineBundle(props.bundleId);
  modalRef.value?.close();
  alerts.success('Application declined');
}

defineExpose({ modalRef });
</script>

<style scoped lang="scss">
.modal {
  max-width: 37rem;
}

.actions > * {
  width: 100%;
}
</style>
